export default class extends Controller {
  connect() {
    this.closeIfOutsideClick = this.closeIfOutsideClick.bind(this);
  }

  toggle() {
    this.isExpanded = !this.element.classList.contains('active');
  }

  //
  // INTERNAL USE
  //

  closeIfOutsideClick(event) {
    event.target !== this.element && !this.element.contains(event.target) && this.closeExpandedContent();
  }

  closeExpandedContent(event) {
    event && event.stopImmediatePropagation();
    this.isExpanded = false;
  }

  //
  // GETTERS AND SETTERS
  //

  set isExpanded(val) {
    this.element.classList[val ? 'add' : 'remove']('active');
    document[`${val ? 'add' : 'remove'}EventListener`]('click', this.closeIfOutsideClick);
  }
};



// WEBPACK FOOTER //
// ./app/components/buttons/ellipsis/assets/javascript/buttons-ellipsis-dropdown-button-controller.js